import React from 'react';
import { MUTED } from './tokens';
import { useSoft } from './SurfaceStyleContext';

/**
 * N-up stats. Desktop: bordered card, 20px numbers. Mobile: border-bottom strip, 17px numbers.
 * stats: [{ n, k, color }]. Green (#15803D) is for friend / went / rated / your-ticket counts.
 */
export default function StatStrip({ stats = [], mobile = false, cols, className = '', dark = false, testId }) {
  const n = cols || stats.length || 1;
  const soft = useSoft();
  if (soft) {
    // Soft: white cells with 2px canvas gaps; 22px/800 numbers (16 on phones), 9px labels.
    return (
      <div className={`grid ${className}`} style={{ gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))`, gap: 2, background: dark ? '#000' : '#F5F5F5' }} data-testid={testId} data-soft="1">
        {stats.map((s, i) => (
          <div key={`${s.k}-${i}`} className="flex flex-col items-center text-center" style={{ gap: mobile ? 4 : 6, padding: mobile ? '14px 6px' : '22px 10px', background: dark ? '#111' : '#fff' }}>
            <span className="font-mono" style={{ fontSize: mobile ? 16 : (s.size || 22), fontWeight: 800, color: s.color || (dark ? '#fff' : '#000'), overflowWrap: 'anywhere' }}>{s.n}</span>
            <span className="font-mono font-bold uppercase" style={{ fontSize: mobile ? 8 : 9, letterSpacing: mobile ? '0.14em' : '0.16em', color: dark ? '#9CA3AF' : MUTED }}>{s.k}</span>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div
      className={`grid ${mobile ? 'border-b-2' : 'border-2'} ${dark ? 'border-white bg-black text-white' : 'border-black bg-white'} ${className}`}
      style={{ gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))` }}
      data-testid={testId}
    >
      {stats.map((s, i) => (
        <div
          key={`${s.k}-${i}`}
          className="text-center"
          style={{ padding: mobile ? '13px 6px' : '16px 8px', borderLeft: i > 0 ? `2px solid ${dark ? '#fff' : '#000'}` : 'none' }}
        >
          <div className="font-mono font-bold" style={{ fontSize: mobile ? 17 : (s.size || 20), color: s.color || (dark ? '#fff' : '#000'), overflowWrap: 'anywhere' }}>{s.n}</div>
          <div className="font-mono font-bold uppercase" style={{ fontSize: 9, letterSpacing: '0.1em', color: dark ? '#9CA3AF' : MUTED }}>{s.k}</div>
        </div>
      ))}
    </div>
  );
}
